import { useDisclosure } from '@chakra-ui/core';
import React from 'react';

export const useTabsWithConfirm = (onConfirmLeaveCallback?: (fromIndex: number) => void) => {
  const [tabIndex, setTabIndex] = React.useState(0);
  const [nextTabIndex, setNextTabIndex] = React.useState(0);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleTabChange = (index: number, isCurrentTabDirty: boolean) => {
    if (isCurrentTabDirty) {
      setNextTabIndex(index);
      onOpen();
    } else {
      setTabIndex(index);
    }
  };

  const onConfirmLeave = () => {
    onConfirmLeaveCallback?.(tabIndex);
    setTabIndex(nextTabIndex);
    onClose();
  };

  const onCancelLeave = () => {
    onClose();
  };

  return {
    tabIndex,
    handleTabChange,
    confirmModal: {
      isOpen,
      onConfirm: onConfirmLeave,
      onCancel: onCancelLeave,
    },
  };
};
